<div class="card-body">
  <div class="p-3">
    <div class="row">
      <h4 class="card-title">{{'cliente.sezioni.sedi'|translate}}
        <span class="badge badge-info badge-pill px-3 font-weight-bold font-14" *ngIf="sediFiltrate">{{sediFiltrate.length}}</span>
      </h4>
      <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1" *ngIf="permission.isPermitted('gestione-sedi') || profile">
        <button class="btn btn-outline-info rounded-pill" style="width: 100%;"  (click)="openModal(EditModal, null)"
          type="button">Aggiungi</button>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="environment['ClientiAddOn'] && environment.ClientiAddOn['FiltriSede']">
    <h5 class="card-title" > Filtri</h5>
    <div class="card-body">
      <app-field-viewer [Campi]="environment.ClientiAddOn['FiltriSede']" [(Oggetto)]="Filters" (OnChange)="refresh()"></app-field-viewer>
    </div>
  </div>
  <div class="table-responsive" *ngIf="sediFiltrate?.length > 0" >
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
      <thead>
        <tr>
          <th>Indirizzo</th>
          <th scope="col">Città</th>
          <th scope="col">Email</th>
          <th scope="col">Telefono / Fax</th>
          <th scope="col">Note</th>
          <th scope="col">Tipo</th>
          <th scope="col" *ngIf="permission.isPermitted('gestione-sedi')">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sediFiltrate">
          <td class="align-middle" (click)='openModal(EditModal, item)'>
            <span>
              <span class="badge badge-light text-info rounded-pill font-16 mr-1">
                <i class="far fa-address-card"></i>
              </span>
              {{ item.indirizzo }}
            </span>
          </td>
          <td class="align-middle"  (click)='openModal(EditModal, item)'>
            <span>
              <span class="badge badge-light text-orange rounded-pill font-16 mr-1">
                <i class="fas fa-map-signs"></i>
              </span>
              {{ item.citta}}, {{item.provincia}} {{item.cap}}
            </span>

          </td>
          <td class="align-middle">
            <span >
              <span class="badge badge-light text-cyan rounded-pill font-16 mr-1">
                <i class="far fa-envelope-open"></i>
              </span>
              <a href="mailto:{{item.email}}">
                {{ item.email }}
              </a>
            </span>

          </td>
          <td class="align-middle"  (click)='openModal(EditModal, item)'>
            <span >
              <span class="badge badge-light text-success rounded-pill font-16 mr-1">
                <i class="fas fa-phone"></i>
              </span>
              {{ item.telefono}} &nbsp; {{item.fax}}
            </span>

          </td>
          <td class="align-middle"  (click)='openModal(EditModal, item)'>
            <span >
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i-feather name="info" class="feather-sm"></i-feather>
              </span>
              {{ item.note}}
            </span>
          </td>
          <td class="align-middle"  (click)='openModal(EditModal, item)'>
            <span>
              <div *ngFor="let val  of item.tipiObject" >
                {{ val.label}} &nbsp;
              </div>

            </span>
          </td>
          <td class="align-middle" *ngIf="permission.isPermitted('gestione-sedi')">
            <a  href="javascript:void(0)" ngbTooltip="Modifica"
              class="link font-16 text-info font-medium mr-2" (click)='openModal(EditModal, item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
              (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>



<ng-template #EditModal let-modal>
  <div class="modal-header">
    <h5 *ngIf="selectedSede && selectedSede != null && selectedSede.id > 0"  class="modal-title" id="editUserLabel">Modifica Sede</h5>
    <h5 *ngIf="selectedSede && selectedSede != null && selectedSede.id == undefined" class="modal-title" id="editUserLabel">Aggiungi Sede</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="selectedSede && selectedSede != null && !environment.ClientiAddOn['CampiSede']" class="modal-body">
    <div class="row">
    <div class="col-lg-3 ">
      <div *ngIf="DropdownSources.tipologieSedi" class="">
        <label class="control-label col-form-label">Tipologia sede</label>
        <ng-multiselect-dropdown required [settings]="dropdownSettings" [placeholder]="'Seleziona'" name="sede"
          [data]="DropdownSources.tipologieSedi" [(ngModel)]="selectedSede.tipiObject">
        </ng-multiselect-dropdown>
      </div>
    </div>
      <div class="col-lg-12"></div>
    <div class="col-lg-4">
      <div class="form-group">
        <label for="indirizzo" class="control-label col-form-label">Indirizzo:</label>
        <input type="text" required [(ngModel)]="selectedSede.indirizzo" class="form-control" id="indirizzo" placeholder="indirizzo">
      </div>
    </div>
      <div class="col-lg-1">
        <div class="form-group">
          <label for="cap" class="control-label col-form-label">Cap:</label>
          <input type="text" required [(ngModel)]="selectedSede.cap" class="form-control" id="cap"
            placeholder="cap">
        </div>
      </div>
    <div class="col-lg-3">
      <div class="form-group">
        <label for="citta" class="control-label col-form-label">Citta:</label>
        <input type="text" required [(ngModel)]="selectedSede.citta" class="form-control" id="citta"
               placeholder="citta">
      </div>
    </div>
      <div class="col-lg-3">
        <div class="form-group">
          <label for="provincia" class="control-label col-form-label">Provincia:</label>
          <input type="text" required [(ngModel)]="selectedSede.provincia" class="form-control" id="provincia" placeholder="provincia">
        </div>
      </div>
      <div class="col-lg-3" *ngIf="environment.ClientiAddOn['regione']">
        <div class="form-group">
          <label for="provincia" class="control-label col-form-label">Regione:</label>
          <input type="text" required [(ngModel)]="selectedSede.regione" class="form-control" id="regione" placeholder="regione">
        </div>
      </div>

    <div class="col-12">
      <div class="form-group">
        <label for="email" class="control-label col-form-label">Email:</label>
        <input type="text" [(ngModel)]="selectedSede.email" class="form-control" id="email" placeholder="email">
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="telefono" class="control-label col-form-label">Telefono:</label>
        <input type="text" [(ngModel)]="selectedSede.telefono" class="form-control" id="telefono" placeholder="telefono">
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="fax" class="control-label col-form-label">Fax:</label>
        <input type="text" [(ngModel)]="selectedSede.fax" class="form-control" id="fax" placeholder="fax">
      </div>
    </div>
    <div class="row " style="padding-left: 10px; padding-right: 10px;">
      <div class="col-6">
        <div class="form-group">
          <label for="lat" class="control-label col-form-label">Latitudine:</label>
          <input type="number" ngModel #lat="ngModel" required [(ngModel)]="selectedSede.lat" class="form-control" id="lat" placeholder="lat" >
          <small class="form-text text-danger" *ngIf="lat.errors?.required">Latitudine richiesta</small>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="lon" class="control-label col-form-label">Longitudine:</label>
          <input type="number" ngModel #lon="ngModel" required [(ngModel)]="selectedSede.lon" class="form-control" id="lon"
            placeholder="lon">
          <small class="form-text text-danger" *ngIf="lon.errors?.required">Longitudine richiesta</small>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="note" class="control-label col-form-label">Note:</label>
        <textarea type="text" [(ngModel)]="selectedSede.note" class="form-control" id="note" placeholder="note"></textarea>
      </div>
    </div>
    </div>
  </div>
  <div *ngIf="selectedSede && selectedSede != null && environment.ClientiAddOn['CampiSede']" class="modal-body">
    <app-field-viewer [(DropdownSources)]="DropdownSources" [(Campi)]="environment.ClientiAddOn['CampiSede']" [(Oggetto)]="selectedSede"></app-field-viewer>
  </div>
  <div *ngIf="selectedSede?.id && environment.ClientiAddOn['ProveAcquistoSede']">
    <app-lista-prova-acquisto [(List)]="selectedSede.prove" [HasFilter]="false" [Cliente]="client" [(Sede)]="selectedSede.id" (onRefresh)="refresh()"></app-lista-prova-acquisto>
  </div>
  <div *ngIf="selectedSede?.id && environment.ClientiAddOn['RmaSede']">
    <div class="d-md-flex align-items-center bg-white p-2" >
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{'cliente.sezioni.rma' | translate}}:</h5>
    </span>
      <div class="ml-auto mt-3 mt-md-0" *ngIf="!permission.isOperativeRole('CA')">
        <button type="button" (click)="AddRma()" class="btn btn-cyan rounded-pill p-2" ><i
          class="fas fa-plus  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">{{'RMA.add' | translate}}</span>
        </button>
      </div>
    </div>
    <app-rma-list [filtri]="{page:0, size:100, tipo: 'R', sede: selectedSede.id, figli: false }"></app-rma-list>
  </div>
  <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
    <button (click)="saveModalButton()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
      <span class="ml-1 text-white font-weight-bold"> Salva </span>
      <i-feather name="save" class="feather-md "></i-feather>
    </button>
  </div>
</ng-template>
